//https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/random
/**
 * @param min Inclusive
 * @param max Exclusive
 * @returns {*}
 */
export function getRandomArbitrary(min, max) {
  return Math.random() * (max - min) + min;
}

/**
 * @param min Inclusive
 * @param max Exclusive
 * @returns {number}
 */
export function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min;
}

/**
 * @param min Inclusive
 * @param max Inclusive
 * @returns {number}
 */
export function getRandomIntInclusive(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function coinFlip() {
  return getRandomIntInclusive(0, 1) === 0;
}

export function clamp(n, min, max) {
  return Math.min(Math.max(n, min), max);
}



// WEBPACK FOOTER //
// ./src/app/utils/number.js